import { Card, Col } from "reactstrap";
import CommonTable from "../Common/CommonTable";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { HoverableRowsWithHorizontalBorders } from "../../../../Constant";
import { HOVERABLE_ROW, HOVERABLE_ROW_BODY, HOVERABLE_ROW_HEAD } from "../../../../Data/BootstrapTable/BasicTable";

export const HoverableRows = () => {
  return (
    <Col sm="12">
      <Card className="hoverable-table">
        <CommonCardHeader title={HoverableRowsWithHorizontalBorders} span={HOVERABLE_ROW} table />
        <CommonTable tableClass="signal-table" headData={HOVERABLE_ROW_HEAD} hover>
          {HOVERABLE_ROW_BODY.map((data) => (
            <tr key={data.id}>
              <th scope="row">{data.id}</th>
              <td className="d-flex align-items-center">
                {data.icon}
                <span className={`font-${data.color}`}>{data.status}</span>
              </td>
              <td>{data.signalName}</td>
              <td>{data.security}</td>
              <td>{data.stage}</td>
              <td>{data.schedule}</td>
              <td>{data.teamLead}</td>
            </tr>
          ))}
        </CommonTable>
      </Card>
    </Col>
  );
};
